import React from 'react';

import { Stack, Switch, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';

import type { Control } from 'react-hook-form';

import TextFieldComp from '@/components/TextFieldComp';
import TimeFieldComp from '@/components/TimeFieldComp';

/**
 * DrugInputType
 */
export type DrugInputType = {
  /** 昨日で登録 */
  isYesterday: boolean,
  /** 薬 */
  drugContent: string,
  /** 測定日時 */
  measureDateTime: string,
}

/**
 * DrugFormInputType
 */
export type DrugFormInputType = {
  /** コントロール */
  control: Control<DrugInputType, never>,
  /** エラー */
  errors: any,
}

const DrugFormInput: React.FC<DrugFormInputType> = ({
  control,
  errors,
}) => (
  <div>
    <div style={{ margin: '10px 0' }}>
      <Controller
        render={({ field }) => (
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            <Switch defaultChecked={field.value} onChange={field.onChange} />
            <Typography>昨日の薬で登録</Typography>
          </Stack>
        )}
        name="isYesterday"
        control={control as any}
      />
    </div>
    <TextFieldComp
      type="text"
      control={control}
      rules={{
        required: '必須項目です',
      }}
      name="drugContent"
      label="薬内容"
      placeholder="アスピリン"
      errors={errors}
      multiline
      rows={5}
    />
    <TimeFieldComp
      control={control}
      name="measureDateTime"
      label="日時"
      rules={{
        required: '必須項目です',
      }}
      errors={errors}
    />
  </div>
);

export default DrugFormInput;
